import { transformCdnImageUrl } from "seneca-common/utils/images";

import { ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: ContentSource): Array<string> {
  return source.imageURL ? [source.imageURL] : [];
}

export function transformModuleAssets(
  source: ContentSource,
  assetParams: ImageAssetParameters
): ContentSource {
  if (source.imageURL) {
    return {
      ...source,
      imageURL: transformCdnImageUrl(source.imageURL, assetParams.default)
    };
  }

  return source;
}
